import { LocalizationKeys } from '../i18n'

export interface ISearchCategory {
  labelKey: string
  value: string
  depth: number
}

export const searchCategories: ISearchCategory[] = [
  { labelKey: LocalizationKeys.SEARCH_ALL, value: 'all', depth: 0 },
  { labelKey: LocalizationKeys.SEARCH_CONTENT, value: 'content', depth: 0 },
  { labelKey: LocalizationKeys.SEARCH_MOVIES, value: 'movies', depth: 1 },
  { labelKey: LocalizationKeys.SEARCH_TV_SHOWS, value: 'tv-shows', depth: 1 },
  { labelKey: LocalizationKeys.SEARCH_BOOKS, value: 'books', depth: 1 },
  { labelKey: LocalizationKeys.SEARCH_COMICS, value: 'comics', depth: 1 },
  { labelKey: LocalizationKeys.SEARCH_GAMES, value: 'games', depth: 1 },
  { labelKey: LocalizationKeys.SEARCH_USERS, value: 'users', depth: 0 },
  { labelKey: LocalizationKeys.SEARCH_PERSONS, value: 'persons', depth: 0 },
  { labelKey: LocalizationKeys.SEARCH_COLLECTIONS, value: 'collections', depth: 0 },
  { labelKey: LocalizationKeys.SEARCH_FAVORITES, value: 'favCollection', depth: 1 },
  { labelKey: LocalizationKeys.SEARCH_USER, value: 'userCollection', depth: 1 },
  { labelKey: LocalizationKeys.SEARCH_COMMUNITY, value: 'communityCollection', depth: 1 },
]

export const defaultSearchCategory = searchCategories[0]
